const FALLBACK_SYSTEM_VERSION = "unknown";
type PackageJsonLike = { version?: unknown };

function readPackageVersion(): unknown {
    try {
        const packageJson = require("../../../package.json") as PackageJsonLike;
        return packageJson?.version;
    } catch {
        return undefined;
    }
}

function normalizeVersion(value: unknown): string {
    if (typeof value !== "string") {
        return FALLBACK_SYSTEM_VERSION;
    }

    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : FALLBACK_SYSTEM_VERSION;
}

export function getSystemVersion(): string {
    return normalizeVersion(readPackageVersion());
}

/** First two dot-separated segments of package version (e.g. 2.2.00 → 2.2) for admin help URLs. */
export function getAdminHelpReleaseVersion(): string {
    const version = getSystemVersion();
    if (version === FALLBACK_SYSTEM_VERSION) {
        return FALLBACK_SYSTEM_VERSION;
    }
    const segments = version.split(".");
    if (segments.length < 2) {
        return version;
    }
    return `${segments[0]}.${segments[1]}`;
}

export { FALLBACK_SYSTEM_VERSION };
